module.exports = __webpack_public_path__ + "media/Video 50.7f6f93e4.mp4";